// libraries
import valueInvoke from "@splitfire-agency/raiden-library/dist/libraries/utils/valueInvoke";

const defaultWhitelist = {
  "data.email": true,
  "data.user_type": true,
};

export default function usersPasswordResetsSerializeCreate({
  fields,
  whitelist = defaultWhitelist,
}) {
  whitelist = valueInvoke(whitelist, defaultWhitelist);

  return {
    data: {
      email: whitelist["data.email"] ? fields?.data?.email : undefined,

      user_type: whitelist["data.user_type"]
        ? fields?.data?.user_type
        : undefined,
    },
  };
}
